import { render, staticRenderFns } from "./ModalDelete.vue?vue&type=template&id=fa9fe8b8&scoped=true&"
import script from "./ModalDelete.vue?vue&type=script&lang=js&"
export * from "./ModalDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalDelete.vue?vue&type=style&index=0&id=fa9fe8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9fe8b8",
  null
  
)

export default component.exports